export function renderAgreementLegalText(source, formData = {}) {
  const values = formData || {};
  const sleepRate = String(values.sleep_in_rate || '').trim();
  const legacySleepClause = sleepRate
    ? `Where an accepted assignment includes a sleep-in, the stated sleep-in rate is **£${sleepRate} per night**. Any time that counts as working time for National Minimum Wage purposes will be treated and paid in accordance with the law.`
    : 'Where an accepted assignment includes a sleep-in, the applicable rate and arrangements will be confirmed in writing before the assignment is accepted. Any time that counts as working time for National Minimum Wage purposes will be treated and paid in accordance with the law.';

  return String(source || '')
    .replace(
      'If you will be required to sleep in at the clients premises, you will be paid **£{{sleep_in_rate}}** per night.',
      legacySleepClause,
    )
    .replace(/\{\{employee_name\}\}/g, values.employee_name || '[Employee Name]')
    .replace(/\{\{job_title\}\}/g, values.job_title || '[Job Title]')
    .replace(/\{\{start_date\}\}/g, values.start_date || '[Start Date]')
    .replace(/\{\{continuous_service_date\}\}/g, values.continuous_service_date || '[Continuous Service Date]')
    .replace(/\{\{hourly_rate\}\}/g, values.hourly_rate || '[Hourly Rate]')
    .replace(/\{\{sleep_in_rate\}\}/g, sleepRate || '[rate to be confirmed]');
}
